import { render, staticRenderFns } from "./video_editor.vue?vue&type=template&id=058bc9a6&scoped=true&"
import script from "./video_editor.vue?vue&type=script&lang=js&"
export * from "./video_editor.vue?vue&type=script&lang=js&"
import style0 from "./video_editor.vue?vue&type=style&index=0&id=058bc9a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058bc9a6",
  null
  
)

export default component.exports